const eur = new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' });
const dateTime = new Intl.DateTimeFormat('pt-PT', { dateStyle: 'medium', timeStyle: 'short' });
// Departures are read in the operator's local time (Cabo Verde, UTC-1), not the viewer's browser zone.
const caboVerdeTime = new Intl.DateTimeFormat('pt-PT', { timeZone: 'Atlantic/Cape_Verde', hour: '2-digit', minute: '2-digit' });
const caboVerdeWeekdayDay = new Intl.DateTimeFormat('pt-PT', { timeZone: 'Atlantic/Cape_Verde', weekday: 'short', day: '2-digit', month: '2-digit' });
const dayLong = new Intl.DateTimeFormat('pt-PT', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
const monthLong = new Intl.DateTimeFormat('pt-PT', { month: 'long', year: 'numeric' });
const monthName = new Intl.DateTimeFormat('pt-PT', { month: 'long' });

export function formatEur(value: number): string {
  return eur.format(value);
}

export function formatDateTime(iso: string): string {
  return dateTime.format(new Date(iso));
}

export function formatCaboVerdeTime(iso: string): string {
  return caboVerdeTime.format(new Date(iso));
}

/** Weekday, day/month and time in Cabo Verde local time for the Pedidos card, e.g. "quarta, 14/10 · 09:00". */
export function formatCaboVerdeDayTime(iso: string): string {
  const d = new Date(iso);
  return `${caboVerdeWeekdayDay.format(d)} · ${caboVerdeTime.format(d)}`;
}

/** Oldest departure first for the Pedidos list (startsAt is an ISO instant, so a lexical compare is chronological). */
export function sortByDeparture<T extends { startsAt: string }>(items: readonly T[]): T[] {
  return [...items].sort((a, b) => a.startsAt.localeCompare(b.startsAt));
}

/** A yyyy-MM-dd calendar day as a long Portuguese label, read on that date (no time-zone shift). */
export function formatDayLabel(ymd: string): string {
  const [y, m, d] = ymd.split('-').map(Number);
  return dayLong.format(new Date(y, m - 1, d));
}

/** A yyyy-MM month as "outubro de 2026". */
export function formatMonthLabel(ym: string): string {
  const [y, m] = ym.split('-').map(Number);
  return monthLong.format(new Date(y, m - 1, 1));
}

/** A yyyy-MM month as just its name, "setembro". */
export function formatMonthName(ym: string): string {
  const [y, m] = ym.split('-').map(Number);
  return monthName.format(new Date(y, m - 1, 1));
}

const CHANNEL_LABELS: Record<string, string> = {
  WalkIn: 'Walk-in',
  Ota: 'OTA (GetYourGuide/Viator)',
  OwnSite: 'Site próprio'
};

export function channelLabel(channel: string): string {
  return CHANNEL_LABELS[channel] ?? channel;
}

/** A `tel:` href with the number reduced to a leading '+' and digits — never encodeURIComponent, whose %2B can
 * stop a dialer from recognising the country code. */
export function telHref(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, '')}`;
}
